import { LicenseTerm, LicenseTermApi } from '../../../../domainModels/licenseTerms/LicenseTerm';
import { createDateFromTimeZone } from '../../../../helpers/moment';

export const mapApiLicenseTermsModel = (model: LicenseTermApi): LicenseTerm => ({
    ...model,
    startDate: createDateFromTimeZone(model.startDate, undefined, 'utc'),
    endDate: createDateFromTimeZone(model.endDate, undefined, 'utc'),
});
